import React from "react";
import { useTranslation } from "react-i18next";

function Regulations() {
  const { t } = useTranslation();
  const pdfs = [
    { name: t("documents.items.membership"), file: "/pdfs/DEKLARACJA%20CZŁONKOWSKA%20GOATS%20Karate%20Team%20Poznań.pdf" },
    { name: t("documents.items.regulations"), file: "/pdfs/Regulamin%20GOATS%20Karate.pdf" },
    { name: t("documents.items.preschoolMembership"), file: "/pdfs/Regulamin%20i%20deklaracja%20przedszkola%20GOATS%20Karate.pdf" },
    { name: t("documents.items.protection"), file: "/pdfs/Standardy%20ochrony%20małoletnich.pdf" },
    { name: t("documents.items.statute"), file: "/pdfs/statut.pdf" },
  ];

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-gold">{t("documents.title")}</h2>
      <ul className="list-group shadow rounded-3">
        {pdfs.map((pdf) => (
          <li key={pdf.file} className="list-group-item d-flex justify-content-between align-items-center">
            <span>{pdf.name}</span>
            <a
                href={pdf.file}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-warning btn-sm"
            >
              {t("documents.download")}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Regulations;